import React from 'react'
//import {postApi} from '../utils/functions';
import EventEmitter from '../utils/emmiter';
import {UserContext} from '../utils/usercontext';

//---- Class components
import EmojisEmotes from './emojisemotes';
//import Emotes from './components/emotes';
//import Messaging from './components/messaging';
import GiphyTenor from './giphytenor';
import Clock from './clock';
import TrackID from './trackid';

import Functions from './functions';

/*

  This will be the main controller for the front end template

  Ideally the canvas will only be displayed whilst theres something active being rendered

  Message Stream should be the only one that are excluded from this

  Must mind about the draw inside useEffect???
*/



export default class Canvas extends React.Component {
  static contextType = UserContext;

  #timeframe = 0;

  #refCanvas;
  #refEmojisEmotes;
  #refMessaging;
  #refGiphyTenor;
  #refClock;
  #refTrackid;

  #refFunctions;


  constructor(props) {
    super(props);
    this.state = {
			active: true,
			
      settings: props.settings,
      servicemode: props.servicemode,
      /*content: {},*/
      /*messages: [],*/

      emojisemotes: [],
      giphytenor: [[],[],[]],
      giphytenorIndex: 0,

      ListenerSettings: null,
      ListenerEmojis: null,
      ListenerEmotes: null,
      ListenerGiphyTenor: null,
      ListenerMessages: null,
			
		};
    //console.log(props.servicemode);

    //---- Create Refs
    this.refCanvas = React.createRef();
		//console.log(this.props);

    this.refEmojisEmotes = React.createRef();
    if (!this.refEmojisEmotes.current) this.refEmojisEmotes.current = new EmojisEmotes(props);
    //this.emotes = React.createRef();
    //if (!this.emotes.current) this.emotes.current = new Emotes(props);
    //this.refMessaging = React.createRef();
    //if (!this.refMessaging.current) this.refMessaging.current = new refMessaging(props);
    
    this.refGiphyTenor = React.createRef();
    if( !this.refGiphyTenor.current ) this.refGiphyTenor.current = new GiphyTenor(props);

    this.refClock = React.createRef();
    if( !this.refClock.current ) this.refClock.current = new Clock(props);

    if( this.state.servicemode >= 4 ) {
      this.refTrackid = React.createRef();
      if (!this.refTrackid.current) this.refTrackid.current = new TrackID(props);
    }
    

    this.refFunctions = React.createRef();
    if (!this.refFunctions.current) this.refFunctions.current = new Functions(props);

		
    this.checkContent = this.checkContent.bind(this);
    //this.loadEmotes = this.loadEmotes.bind(this);
    this.recycler = this.recycler.bind(this);
    this.paint = this.paint.bind(this);

    //---- TEST
    setTimeout(()=>{
      //this.refMessaging.current.say({ channel: "bpm", ctime: 0, left: 0, top: 0, avatar: "https://thumbnailer.mixcloud.com/unsafe/24x24/profile/1/1/a/d/f00a-7ec1-4525-a693-e6aa6b97a0a2", title: "ScottyM", isPro: false, isSub: false, body: "tune here" });
    }, 3000);
    
  };

  //canvasRef = createRef();

  componentDidMount() {
    //const canvas = this.refCanvas.current;
    //const ctx = canvas.getContext("2d");

    this.animation = requestAnimationFrame(this.paint);


    //---- EmojiCrew user template settings
    const ListenerSettings = EventEmitter.addListener('/template/settings', async data => {
      let settings = this.state.settings;
			if( data.servicekey === this.props.servicekey ) {
				for( let i in data.template ) settings[i] = data.template[i];
				this.setState({settings: {}}, ()=>{
					this.setState({settings});
				});
			}
    }); this.setState({ListenerSettings});


    //---- EmojiCrew emoji emotes
    const ListenerEmojis = EventEmitter.addListener('/template/emojisemotes', async data => {
      const value = this.context;
      //console.log(data);
      //---- Store emoji into content to be re-used
      let content = this.state.content;
      if( !content ) content = {};
      //let _content = [];
      for( let i in data.animations ) {
        //---- Load Emojis
        if( await this.checkContent(data.animations[i].data) === false ) {
          let emoji = await this.refFunctions.current.loadContentEmoji(value.worker[data.service], data.animations[i].data, 'emojis');
          content[data.animations[i].data] = emoji;
        }
      }

      //---- Check and create emojis
      let emojisemotes = this.state.emojisemotes;
      if( !emojisemotes ) emojisemotes = [];
      for( let i in data.animations ) {
        data.animations[i] = await this.refEmojisEmotes.current.process(data.animations[i], content[data.animations[i].data], this.timeframe, parseInt(i));
        data.animations[i].ctime = Date.now();
        //console.log(data.animations[i]);
		    emojisemotes.push(data.animations[i]);
      }
      //---- Save
      //console.log(content, emojisemotes);
      this.setState({content, emojisemotes});
    }); this.setState({ListenerEmojis});


    /*
    const ListenerEmotes = EventEmitter.addListener('/template/emotes', async data => {
      let content = this.state.content;
      if( !content ) content = {};
      console.log(data);

      for( let i in data.animations ) {
        if( await this.checkContent(data.animations[i].data) === false ) {
          let emote = await this.refFunctions.current.loadContentEmotes(data.animations[i].data);
          content[data.animations[i].data] = emote;
        }
      }

      //---- Check and create emotes
      let emotes = this.state.emotes;
      if( !emotes ) emotes = [];
      for( let i in data.animations ) {
        let emote = await this.emotes.current.process(data.animations[i], content[data.animations[i].data], this.timeframe, parseInt(i));
        //console.log(emote);
        emotes.push(emote);
      }
      //---- Save
      console.log(content, emotes);
      this.setState({content, emotes});
      


    }); this.setState({ListenerEmotes});
    */


    const ListenerMessages = EventEmitter.addListener('/template/message', async data => {
      //console.log(data);
      //---- Load Avatar
      if( await this.checkContent(data.avatar) === false ) {
        let avatar = await this.refFunctions.current.loadContentImage(data.avatar);
        let content = this.state.content;
        if( !content ) content = {};
        content[data.avatar] = avatar;
        this.setState({content});
      }
      //---- Store message
      let message = await this.refMessaging.current.process(data);
      let messages = this.state.messages;
      if( !messages ) messages = [];
		  messages.push(message);
			//console.log(messages);
      this.setState({messages});
    }); this.setState({ListenerMessages});

    const ListenerGiphyTenor = EventEmitter.addListener('/template/giphytenor', async data => {
      //console.log("giphytenor", data);

      let content = this.state.content;
      if( !content ) content = {};
      //let _content = [];
      //for( let i in data.animations ) {
        //---- Load giphytenor
      if( await this.checkContent(data.giphytenor) === false ) {
        let gt = await this.refFunctions.current.loadContentEmoji(data.giphytenor, 'giphytenor', true);
        content[data.giphytenor] = gt;
      }
      //}
      //console.log(this.state.settings.GiphyTenor, this.state.giphytenorIndex);

      //---- Check and create emojis
      let giphytenor = this.state.giphytenor;
      if( !giphytenor ) giphytenor = [[],[],[]];
      
      data.giphytenor = await this.refGiphyTenor.current.process(data.giphytenor, content[data.giphytenor], this.timeframe, 0);

      //console.log(data.giphytenor);
      //---- Which array are we posting into
      //---- Stack to next array, if not cloned
      switch( this.state.settings.GiphyTenor.modal ) {
        case 'Rotation':
          //console.log("Roation", this.state.settings.GiphyTenor.settings.length);
          let index = this.state.giphytenorIndex;

          data.giphytenor.x = this.state.settings.GiphyTenor.settings[index][0];
          data.giphytenor.y = this.state.settings.GiphyTenor.settings[index][1];
          data.giphytenor.width = this.state.settings.GiphyTenor.settings[index][2];
          data.giphytenor.height = this.state.settings.GiphyTenor.settings[index][3];

          giphytenor[index].push(data.giphytenor);
          
          index = index + 1;
          if( index >= this.state.settings.GiphyTenor.settings.length ) index = 0;
          //console.log("index:", index);
          this.setState({giphytenorIndex: index});

        break;
        case 'Clone':

          for( let i in this.state.settings.GiphyTenor.settings ) {
            data.giphytenor.x = this.state.settings.GiphyTenor.settings[i][0];
            data.giphytenor.y = this.state.settings.GiphyTenor.settings[i][1];
            data.giphytenor.width = this.state.settings.GiphyTenor.settings[i][2];
            data.giphytenor.height = this.state.settings.GiphyTenor.settings[i][3];
            giphytenor[i].push({...data.giphytenor});
          }

        break;
      }

      

      //console.log(content, giphytenor);
      this.setState({content, giphytenor});

    }); this.setState({ListenerGiphyTenor});

  }

  componentWillUnmount() {
    cancelAnimationFrame(this.animation);
    if( this.state.ListenerSettings ) this.state.ListenerSettings.remove();
    if( this.state.ListenerEmojis ) this.state.ListenerEmojis.remove();
    if( this.state.ListenerEmotes ) this.state.ListenerEmotes.remove();
    if( this.state.ListenerMessages ) this.state.ListenerMessages.remove();
    if( this.state.ListenerGiphyTenor ) this.state.ListenerGiphyTenor.remove();
  }

  componentDidUpdate(prevProps, prevState) {
  }

  async checkContent(content) {
    let found = false;
    for( let i in this.state.content ) {
      //console.log(i);
      if( content === i ) return true;
    }
    return found;
  }

  async recycler(timeframe) {

    let emojis = this.state.emojisemotes;
    let countemojis = 0;
    for( let i in emojis ) {
      //console.log(emojis[i].state);
      if( !emojis[i].index[emojis[i].state]) countemojis++;
    }
    if( emojis.length !== 0 && emojis.length === countemojis ) {
      this.setState({emojisemotes: []});
      emojis.splice(0,emojis.length);
      emojis = null;
      console.log("emptied!");
    }

    /*for( let i in this.state.emojisemotes ) {

      //console.log( this.state.emojisemotes[i].index.length );

      //---- If on repeat then end after 30 seconds
    if( this.state.emojisemotes[i].repeat === true && Date.now() > this.state.emojisemotes[i].ctime + 30000 ) {
        let emojisemotes = this.state.emojisemotes;
        emojisemotes.splice(i, 1);
        this.setState({emojisemotes});
        return;
      }
      if( this.state.emojisemotes[i].repeat === false ) {
        //console.log( this.state.emojisemotes[i].state, this.state.emojisemotes[i].index.length );
        if( this.state.emojisemotes[i].state === this.state.emojisemotes[i].index.length - 1 ) {
          if( timeframe > this.state.emojisemotes[i].index[this.state.emojisemotes[i].state].begin+this.state.emojisemotes[i].index[this.state.emojisemotes[i].state].duration - 10 ) {
            let emojisemotes = {...this.state.emojisemotes};
            console.log(emojisemotes);
            let temp = emojisemotes[i];
            emojisemotes.splice(i, 1);
            this.setState({emojisemotes});
            temp = null;
          }
        }
      }
      //if( parseInt(i) === 0 ) console.log(this.state.emojisemotes[i].state);

      /*
      if( this.state.emojisemotes[i].maxDuration !== 0 && Date.now() >= this.state.emojisemotes[i].maxDuration ) {
        let emojisemotes = this.state.emojisemotes;
        emojisemotes.splice(i, 1);
        this.setState({emojisemotes});
        return;
      }
      *
    }*/

    for( let i in this.state.giphytenor ) {
      if( this.state.giphytenor[i][0]?.ctime && Date.now() > this.state.giphytenor[i][0].ctime + 30000 ) {
        let giphytenor = {...this.state.giphytenor};
        let temp = giphytenor[i];
        giphytenor[i].splice(0, 1);
        this.setState({giphytenor});
        temp = null;
      }
    }
  }

  async paint(now) {
    
    this.timeframe = now;
    //console.log("ah here!");

    const canvas = this.refCanvas.current;
    const ctx = canvas.getContext('2d');
    
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
    //this.refMessaging.current.paint(ctx);
    /*this.setState({angle: this.state.angle+1});*/

    
    let updateEmojis = await this.refEmojisEmotes.current.paint(ctx, this.state.content, this.state.emojisemotes, now);
    if( updateEmojis) this.setState({emojis: updateEmojis});

    let updateGiphys = await this.refGiphyTenor.current.paint(ctx, this.state.content, this.state.giphytenor, now);
    if( updateGiphys) this.setState({giphytenor: updateGiphys});

    //---- Clock
    if( this.state.settings.Clock ) {
      //console.log(this.props.settings.Clock.color);
      if( this.state.settings.Clock.enabled !== false ) await this.refClock.current.paint(ctx, now, this.state.settings.Clock.settings, this.state.settings.Clock.color);
    }



    //---- Recycler
    await this.recycler(now);
    
    //let updateEmotes = await this.emotes.current.paint(ctx, this.state.content, this.state.emotes, now);
    //if( updateEmotes) this.setState({emotes: updateEmotes});



    this.animation = requestAnimationFrame(this.paint);

  }

  
  render() {
    
    return (
      <>
        {this.state.active === true ?
          <canvas ref={this.refCanvas} {...this.props} style={{position: 'absolute', left: 0, top: 0}} />
        :
          <></>
        }
      </>
    
    )
  }
}

